import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['textarea', 'counter'];

  initialize() {
    this.maxlength = this.textareaTarget.maxLength;

    this.textareaTarget.addEventListener('input', () => {
      this.counterTarget.innerHTML =
        this.maxlength - this.textareaTarget.value.length;
    });
  }
}
